import { render, staticRenderFns } from "./incidentReportDeadly.vue?vue&type=template&id=4f79069e"
import script from "./incidentReportDeadly.vue?vue&type=script&lang=js"
export * from "./incidentReportDeadly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports